import { Clipboard } from '@angular/cdk/clipboard';
import { Injectable } from '@angular/core';
import { ToastService } from '../../@theme/service/toast.service';

@Injectable({
  providedIn: 'root',
})
export class ClipboardService {
  constructor(private clipboard: Clipboard, private toast: ToastService) {}

  public copy(value: any, showToast: boolean = false): boolean {

    if (showToast) {
      const result: boolean = this.clipboard.copy(value);
      this.toast.showToast(result ? 'success' : 'danger', result ? '클립보드에 저장되었습니다.' : '클립보드에 저장중 오류가 발생 되었습니다.');
      return result;
    } else {
      return this.clipboard.copy(value);
    }
  }

}
